<template>
  <tr>
    <td>
      {{ localModelValue.transaction_limit_id || '#' }}
    </td>
    <td>
      <v-select
        class="mt-0 pt-0"
        v-model="localModelValue.entity_id"
        :items="entityOptions"
        :return-object="false"
        hide-details
      />
    </td>
    <td>
      <v-select
        v-model="localModelValue.type"
        :items="typeOptions"
      />
    </td>
    <td>
      <v-text-field
        v-model="localModelValue.min_limit"
        class="mt-0 pt-0"
        type="number"
        min="0"
        hide-details
      />
    </td>
    <td>
      <v-text-field
        v-model="localModelValue.max_limit"
        class="mt-0 pt-0"
        type="number"
        min="0"
        hide-details
      />
    </td>
    <td>
      <v-text-field
        v-model="localModelValue.daily_limit"
        class="mt-0 pt-0"
        type="number"
        min="0"
        hide-details
      />
    </td>
    <td>
      <v-text-field
        v-model="localModelValue.weekly_limit"
        class="mt-0 pt-0"
        type="number"
        min="0"
        hide-details
      />
    </td>
    <td>
      <v-text-field
        v-model="localModelValue.monthly_limit"
        class="mt-0 pt-0"
        type="number"
        min="0"
        hide-details
      />
    </td>
    <td class="actions">
      <v-icon
        :disabled="!localModelValue.entity_id || !localModelValue.type"
        @click="$emit('save', localModelValue)"
      >
        save
      </v-icon>
      <v-icon @click="$emit('close')">
        close
      </v-icon>
    </td>
  </tr>
</template>

<script>
import { cloneDeep } from 'lodash';

export default {
  props: {
    transactionLimit: {
      type: Object,
      default: () => ({})
    },
    entitiesById: {
      type: Object,
      default: () => ({})
    },
  },

  data() {
    return {
      localModelValue: {},
      typeOptions: ['balance', 'bonus', 'overdraft', 'sport_bonus', 'freespins']
    }
  },

  mounted() {
    this.localModelValue = cloneDeep(this.transactionLimit)
  },

  computed: {
    entityOptions() {
      return Object.values(this.entitiesById).sort((a, b) => a.value - b.value);
    }
  }
}
</script>

<style lang="scss" scoped>
.actions {
  display: flex;
  gap: 0.5rem;
}
</style>
